"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpMethods = void 0;
exports.httpMethods = ['get', 'post', 'put', 'delete', 'head', 'patch'];
//# sourceMappingURL=types.js.map